<script setup lang="ts">
const props = defineProps<{
  icon: string
  noFill?: boolean
}>()
</script>

<template>
  <span :class="[noFill && 'no-fill']" v-html="props.icon" />
</template>

<style scoped lang="scss">
span {
  display: inline-block;
  font-size: 0;
  height: 100%;
  :deep(svg) {
    width: 100%;
    height: 100%;
  }

  &:not(.no-fill) {
    :deep(svg) {
      [fill]:not([fill='none']) {
        fill: currentColor;
      }
      [stroke]:not([stroke='none']) {
        stroke: currentColor;
      }
    }
  }
}
</style>
